module.exports = __webpack_public_path__ + "img/development-during-recession-top.96baba36.jpeg";